import { render, staticRenderFns } from "./OfficialLeagueGameInfoTemplate.vue?vue&type=template&id=21e17d53&"
import script from "./OfficialLeagueGameInfoTemplate.vue?vue&type=script&lang=js&"
export * from "./OfficialLeagueGameInfoTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OfficialLeagueGameInfoTemplate.vue?vue&type=style&index=0&id=21e17d53&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports